var $c9604d3bf5ac6f77$exports = {};
$c9604d3bf5ac6f77$exports = {
    "alert": `\u{421}\u{438}\u{433}\u{43D}\u{430}\u{43B}`,
    "dismiss": `\u{41E}\u{442}\u{445}\u{432}\u{44A}\u{440}\u{43B}\u{44F}\u{43D}\u{435}`
};


export {$c9604d3bf5ac6f77$exports as default};
//# sourceMappingURL=bg-BG.mjs.map
